import React, { Component } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom'
import IntegrationAutosuggestCurrent from "./IntegrationAutosuggestCurrent";
import Button from '@material-ui/core/Button';
import '../css/CurrentLocation.css'
import PropTypes from 'prop-types';
import deburr from 'lodash/deburr';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import {compose} from 'redux'
import LocalizedStrings from 'react-localization';
import { data } from '../js/data.js';
import '../css/CurrentLocation.css'
import { fontSizeToggleAction } from '../js/actions/fontSizeToggleAction'


let strings = new LocalizedStrings(data);

function renderInputComponent(inputProps) {
    const { classes, inputRef = () => {}, ref, ...other } = inputProps;

    return (
        <TextField
            onChange={{href: "#autocomplete1"}}
            fullWidth
            InputProps={{
                inputRef: node => {
                    ref(node);
                    inputRef(node);
                },
                classes: {
                    input: classes.input,
                },
            }}
            {...other}
        />
    );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
    const matches = match(suggestion.label, query);
    const parts = parse(suggestion.label, matches);

    return (
        <MenuItem selected={isHighlighted} component="div">
            <a name="autocomplete1">
                <div>
                    {parts.map((part, index) =>
                        part.highlight ? (
                            <span key={String(index)} style={{ fontWeight: 500 }}>
                                {part.text}
                            </span>
                        ) : (
                            <strong key={String(index)} style={{ fontWeight: 300 }}>
                                {part.text}
                            </strong>
                        ),
                    )}
                </div>
            </a>
        </MenuItem>
    );
}

function getSuggestionValue(suggestion) {
    return suggestion.label;
}

const styles = theme => ({
    root: {
        height: 250,
        flexGrow: 1,
    },
    container: {
        position: 'relative',
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
        textSize:'200pt'
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
    divider: {
        height: theme.spacing.unit * 2,
    },
});



class CurrentLocation extends Component{

    state = {
        single: '',
        popper: '',
        currentLocation: '',
        suggestions: []
    }

    getSuggestions = (value) => {
        var labels=[]
        var mapList=this.props.maps;
        for(var i = 0; i<mapList.length; i++){
            for(var j = 0; j<mapList[i].nodes.length; j++){
                if(mapList[i].nodes[j].type == 'place'){
                    labels.push({label: mapList[i].nodes[j].name, floor: mapList[i].floorNum})
                }
            }
        }
        const inputValue = deburr(value.trim()).toLowerCase();
        const inputLength = inputValue.length;
        let count = 0;
    
        return inputLength === 0
            ? []
            : labels.filter(suggestion => {
                const keep =
                    count < 5 && suggestion.label.slice(0, inputLength).toLowerCase() === inputValue;
    
                if (keep) {
                    count += 1;
                }
    
                return keep;
            });
    }
    
    handleSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: this.getSuggestions(value),
        });
    };

    handleSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };

    handleChange = name => (event, { newValue }) => {
        this.setState({
            [name]: newValue,
        });
        var mapList=this.props.maps;
        for(var i = 0; i<mapList.length; i++){
            for(var j = 0; j<mapList[i].nodes.length; j++){
                if(mapList[i].nodes[j].name == newValue){
                    this.setState({
                        currentLocation: mapList[i].nodes[j].nodeId
                    })
                }
            }
        }
    };

    handleEmpty = () =>{
        alert("Please Enter a Location Name")
    }

    handleIncorrect = () =>{
        alert("Please Enter a Valid Location Name")
    }

    render(){
        strings.setLanguage(this.props.languages);

        const { classes } = this.props;

        const autosuggestProps = {
            renderInputComponent,
            suggestions: this.state.suggestions,
            onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
            onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
            getSuggestionValue,
            renderSuggestion,
        };

        let enterButton;
        if(this.state.single == ''){
            enterButton = 
                <Button id={(this.props.isFontSizeEnabled ? 'Cur-loc-enter-button-large' : 'Cur-loc-enter-button')}
                    style={{marginBottom: '10px'}}
                    onClick={this.handleEmpty}
                >
                    {strings.enter}
                </Button>
        } else if(this.state.currentLocation != ''){
            enterButton = 
            <Link to={"/destination/" + this.state.currentLocation}>
                <Button id={(this.props.isFontSizeEnabled ? 'Cur-loc-enter-button-large' : 'Cur-loc-enter-button')}
                    style={{marginBottom: '10px'}}
                >
                    {strings.enter}
                </Button>
            </Link>
        } else {
            enterButton = 
                <Button id={(this.props.isFontSizeEnabled ? 'Cur-loc-enter-button-large' : 'Cur-loc-enter-button')}
                    style={{marginBottom: '10px'}}
                    onClick={this.handleIncorrect}
                >
                    {strings.enter}
                </Button>
        }

        return(
            <body>
                <div>
                    <div className="App">
                        <header className="App-header">
                        <p className="Title-one">
                        <h1 className={(this.props.isFontSizeEnabled ? 'Cur-loc-title-one-large' : 'Cur-loc-title-one')}>
                            {strings.enterYour}
                            </h1>
                        </p>
                            <div>
                                <div className={classes.root}>
                                <Autosuggest
                                    {...autosuggestProps}
                                    inputProps={{
                                        id: (this.props.isFontSizeEnabled ? 'Cur-loc-large' : 'Cur-loc'),
                                        classes,
                                        placeholder: (strings.enterYour),
                                        value: this.state.single,
                                        onChange: this.handleChange('single'),
                                    }}
                                    theme={{
                                        container: classes.container,
                                        suggestionsContainerOpen: classes.suggestionsContainerOpen,
                                        suggestionsList: classes.suggestionsList,
                                        suggestion: classes.suggestion,
                                    }}
                                    renderSuggestionsContainer={options => (
                                        <Paper {...options.containerProps} square>
                                            {options.children}
                                        </Paper>
                                    )}
                                />
                                </div>
                                <div>
                                    {enterButton}
                                </div>
                                <div >

                                    <Link to="/">
                                        <Button id={(this.props.isFontSizeEnabled ? 'Cur-loc-enter-button-large' : 'Cur-loc-enter-button')}
                                        style={{marginBottom: '10px'}}
                                        >
                                            {strings.back}
                                        </Button>
                                    </Link>
                                </div>
                                <div id="fontButtons">
                                    <Button id="Font-size-toggle-button"
                                            onClick={this.props.fontSizeToggleAction}
                                            style= {
                                                {
                                                  borderRadius: '2px',
                                                  width: '60px',
                                                  border: 'solid 1px #d8dde3',
                                                  borderColor: '#000'
                                                }
                                            }
                                            >
                                            <i class="material-icons">text_fields</i>
                                    </Button>
                                </div>
                            </div>
                            
                        </header>
                    </div>
                    
                </div>
            </body>
            
        )
    }
}

IntegrationAutosuggestCurrent.propTypes = {
    classes: PropTypes.object.isRequired,
}

const mapDispatchToProps = dispatch => ({
    fontSizeToggleAction: () => dispatch(fontSizeToggleAction),
});

const mapStateToProps = (state) => {
    return {
        maps: state.maps.maps,
        isFontSizeEnabled: state.isFontSizeEnabled.isFontSizeEnabled,
        languages: state.language.language
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(CurrentLocation);
